var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [_vm._v(_vm._s(_vm.title))]),
    _vm._v(" "),
    _c("div", { staticClass: "tag-sections" }, [
      _c(
        "section",
        { staticClass: "tag" },
        [
          _c("p", [
            _vm._v(
              "Gib alle Aufgaben und Tätigkeitsbereiche an, die dich interessieren: das erhöht deine Chancen auf den\n\t\t\t\tpassenden Job!"
            )
          ]),
          _vm._v(" "),
          _c("CharacteristicSelectInline", {
            attrs: {
              "characteristic-items": _vm.functionCharacteristicItems,
              "characteristic-type": _vm.meta.functionType,
              "initial-show-all": _vm.hasFunctions,
              "initial-amount": 10,
              "nothing-allowed": _vm.nothingAllowed,
              "fan-config": {
                nothingAllowed: {
                  minimumLevel: 1
                },
                withKeyword: true,
                showMultipleHint: true,
                titleFormats: {
                  default: "Welche Bereiche in %characteristicLabel%?",
                  level: {
                    1: "Welche Bereiche in %title%?"
                  }
                },
                searchConfig: {
                  catalog: _vm.meta.searchCatalogFunction
                }
              },
              "supplements-config": {
                nothingAllowed: true,
                types: _vm.functionSupplementTypes
              },
              "selected-childs-config": {
                noChildrenAppendix: "Alle Tätigkeiten möglich"
              },
              "show-multiple-hint": "",
              "with-keyword": "",
              "keyword-placeholder": "Suchen ...",
              "search-catalog": _vm.meta.searchCatalogFunction,
              "label-type": "application",
              "group-by-letter": {
                enabled: true
              }
            },
            on: { input: _vm.emitChangeEvent },
            model: {
              value: _vm.functions,
              callback: function($$v) {
                _vm.functions = $$v
              },
              expression: "functions"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }